/**
 * External dependencies
 */
import { useQuery } from '@tanstack/react-query';

/**
 * Internal dependencies
 */
import service from '../service.ts';

export const queryKeys = {
  all: ['purchases'],
  lists: () => [...queryKeys.all, 'list'],
  list: (query: Record<string, unknown>) => [...queryKeys.lists(), { query }],
  details: () => [...queryKeys.all, 'details'],
  detail: (id: string) => [...queryKeys.details(), id],
};

export function useGetPurchases(query?: Record<string, unknown>) {
  return useQuery({
    queryKey: queryKeys.list(query),
    queryFn: async () => {
      return await service.getPurchases(query);
    },
  });
}

export function useGetPurchase(id: string, query?: Record<string, unknown>) {
  return useQuery({
    queryKey: [...queryKeys.detail(id), query],
    queryFn: async () => {
      return await service.getPurchaseById(id, query);
    },
    enabled: !!id,
  });
}
